import React, { useContext, useState, useEffect } from 'react'
import { renderMuiFormField } from 'utils/forms/renderMuiFormField'
import { renderFormField } from 'utils/forms'
import ValuePoint from 'admin/components/ValuePoint'

import { Card, Grid, Typography, Collapse } from '@mui/material'
import { ExpandMore } from '@mui/icons-material'

function Taxes({
  collapseSections,
  toggleCollapse,
  intakeState,
  updateIntakeStateAtKey,
  updateIntakeStateAndSubmit,
}) {
  const [localForm, setLocalForm] = useState({
    taxRate: intakeState.taxRate || '',
  })
  const handleChange = (field) => (value) => {
    setLocalForm((prev) => ({ ...prev, [field]: value }))
  }
  const maritalStatus = intakeState?.maritalStatus

  return (
    <>
      <Grid item xs={12} md={4} xl={3}>
        <Card
          sx={{
            overflow: 'visible',
            textAlign: 'left',
            boxShadow: '0px 4px 25px -8px rgba(0,0,0,0.2)',
            backgroundColor: '#f8f9fa',
            borderRadius: 2,
            p: 2,
          }}
        >
          <Grid container columnSpacing={3} rowSpacing={2}>
            <Grid item xs={12}>
              <Typography variant="valueTitle">VALUE POINTS</Typography>
              <Collapse in={collapseSections.taxes} style={{ width: '100%' }}>
                {maritalStatus === 'married' && (
                  <ValuePoint text="Account for Spousal Income" />
                )}
              </Collapse>
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Grid item xs={12} md={8} xl={9}>
        <Card
          id="taxes"
          sx={{
            overflow: 'visible',
            textAlign: 'left',
            boxShadow: '0px 4px 25px -8px rgba(0,0,0,0.2)',
            borderRadius: 2,
            p: 2,
            pb: 0,
          }}
        >
          <Grid container columnSpacing={3} rowSpacing={2} pb={2}>
            <Grid
              item
              xs={12}
              onClick={() => toggleCollapse('taxes')}
              sx={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Typography variant="h4" sx={{ flexGrow: 1 }}>
                Taxes
              </Typography>
              <ExpandMore
                sx={{
                  height: '1.5em',
                  width: '1.5em',
                  transform: collapseSections.taxes
                    ? 'rotate(180deg)'
                    : 'rotate(0deg)',
                  transition: 'transform 0.3s ease-in-out',
                }}
              />
            </Grid>
          </Grid>
          <Collapse in={collapseSections.taxes} style={{ width: '100%' }}>
            <Grid container columnSpacing={3} rowSpacing={2} pb={2}>
              <Grid item xs={12} sm={6} md={4}>
                {renderMuiFormField({
                  autoFocus: false,
                  id: 'taxRate',
                  label: 'Estimated All-In Tax Rate',
                  placeholder: 'Ex. 15.0%',
                  inputType: 'percentage',
                  value: localForm.taxRate,
                  onChange: (e) => handleChange('taxRate')(e),
                  onBlur: updateIntakeStateAndSubmit((taxRate) =>
                    updateIntakeStateAtKey({ taxRate })
                  ),
                })}
              </Grid>
            </Grid>
          </Collapse>
        </Card>
      </Grid>
    </>
  )
}

export default Taxes
